import React from 'react'
import { Trans, useTranslation } from 'react-i18next'
import Link from 'components/Link'

const WhatIsAlmaAccountInfo = () => {
    const { t } = useTranslation('common')

    return (
        <p>
            <Trans i18nKey="common:login.whatIsAlmaAccount.paragraph1">
                <Link to={t('common:login.whatIsAlmaAccount.readMoreLink')} trackName="readMore">Lue lisää Alma-tunnuksesta</Link>
            </Trans>
        </p>
    )
}

export default WhatIsAlmaAccountInfo
